import clsx from "clsx";
import { Link } from "react-router-dom";

import RenderIf from "common/components/RenderIf";
import Skeleton from "common/components/ui/Skeleton";

import useUrlPreview from "../../../datahooks/useUrlPreview";

import type { MessageLink } from "../../../types";

interface LinkPreviewProps {
  link: MessageLink;
  isMine: boolean;
}

export default function LinkPreview({ link, isMine }: LinkPreviewProps) {
  const { preview, isLoadingPreview } = useUrlPreview(link);

  const containerClassName = clsx(
    "flex-col flex rounded-lg gap-1 mt-2",
    isMine ? "bg-purple-50" : "bg-black-100",
  );
  const contentClassName = "flex flex-col px-2 py-1";

  if (isLoadingPreview) {
    return (
      <div className={containerClassName}>
        <div className={contentClassName}>
          <Skeleton className="h-40 min-w-72 rounded-lg" />

          <div className={contentClassName}>
            <Skeleton className="h-5 w-full mb-1" />
            <div className="flex flex-col gap-0.5">
              <Skeleton className="h-3 w-8/12" />
              <Skeleton className="h-3 w-8/12" />
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (preview?.images.length) {
    const { title, description, images, url: redirectUrl } = preview;

    return (
      <Link to={redirectUrl} target="_blank" className={containerClassName}>
        <img
          src={images[0]}
          className="w-full rounded-lg object-cover max-h-80"
          alt=""
        />
        <div className={contentClassName}>
          <span className="text-sm-bold mb-1">{title}</span>
          <RenderIf condition={!!description}>
            <p className="line-clamp-5 text-sm">{description}</p>
          </RenderIf>
        </div>
      </Link>
    );
  }
}
